import React, { useEffect, } from "react";
import Spinner from './../Spinner';
import { WakeUp, } from '../../services/utils';

const PublicLayout = ({
    loading = false,
    children,
    className,
}) => {

    useEffect(() => {
        WakeUp().then()
            .catch(error => {
                console.error('error: ', error);
            });
    }, []);

    if (loading) {
        return (<Spinner></Spinner>);
    } else {
        return (
            <React.Fragment>
                <main>
                    <div className={`public-container ${className}`}>
                        {children}
                    </div>
                </main>
            </React.Fragment>
        );
    }

};

export default PublicLayout;